import React, { useState } from 'react'
import CloseIcon from '../../assets/icon/CloseIcon'
import Modal from '../Modal'
import styles from './index.module.scss'
import modalStyles from '../ProjectControls/index.module.scss'

interface ConfirmationModalProps {
    isOpen: boolean
    title: string
    text: string
    cancelLabel?: string
    confirmLabel?: string
    confirmTone?: 'primary' | 'danger'
    onCancel: () => void
    onConfirm: () => Promise<void> | void
}

export default function ConfirmationModal({
    isOpen,
    title,
    text,
    cancelLabel = 'Отменить',
    confirmLabel = 'Подтвердить',
    confirmTone = 'primary',
    onCancel,
    onConfirm,
}: ConfirmationModalProps) {
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleCancel = () => {
        if (!isSubmitting) onCancel()
    }

    const handleConfirm = async () => {
        if (isSubmitting) return

        setIsSubmitting(true)
        try {
            await onConfirm()
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleCancel}
            contentLabel={title}
            portalClassName={styles.confirmationPortal}
            width={446}
        >
            <div className={modalStyles.dialog}>
                <button
                    type="button"
                    className={modalStyles.dialogClose}
                    onClick={handleCancel}
                    aria-label="Закрыть окно подтверждения"
                    disabled={isSubmitting}
                >
                    <CloseIcon />
                </button>

                <div className={modalStyles.dialogContent}>
                    <h2 className={modalStyles.dialogTitle}>{title}</h2>
                    <p className={modalStyles.dialogText}>{text}</p>
                </div>

                <div className={modalStyles.dialogActions}>
                    <button
                        type="button"
                        className={modalStyles.secondaryButton}
                        onClick={handleCancel}
                        disabled={isSubmitting}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={confirmTone === 'danger'
                            ? modalStyles.dangerButton
                            : modalStyles.primaryButton}
                        onClick={() => void handleConfirm()}
                        disabled={isSubmitting}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </Modal>
    )
}
